import EditBase from "../EditBase"
import { cartesians2lonlats, lonlats2cartesians } from "../../utils/CoordinateUtil.js"
class EditBezier extends EditBase {

    constructor(options) {
        super(options);
    }

    checkHeightPoint() {
        return false;
    }

    initProperty(bool) {
        var $this = this;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            var positions=$this.plot.attrPlot["edit_positions"];
            var line = turf.lineString($this.cart2Wgs84(positions));
            var curved = turf.bezierSpline(line);
            var coordinates = curved.geometry.coordinates;
            return lonlats2cartesians(coordinates);
        }, bool);
        this.plot.polyline.positions = positionsProperty;
    }
}

export default EditBezier;